import { fetchWithoutToken } from '../utils/fetch';

export const updateToken = async () => {
  // Datos de autenticación
  const USERNAME = process.env.REACT_APP_AUTH_USERNAME;
  const PASSWORD = process.env.REACT_APP_PASSWORD;
  const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
  const INSTITUTION_CODE = process.env.REACT_APP_INSTITUTION_CODE;

  try {
    const response = await fetchWithoutToken.post('/auth', {
      username: USERNAME,
      password: PASSWORD,
      code: ENVIRONMENT === 'PRODUCTION' ? null : INSTITUTION_CODE,
    });
    const { access_token, expires_in } = response.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('expires_in', expires_in);
  } catch (error) {
    console.error('Error during authentication', error);
  }
  return null;
};
